import { get } from './base.service'
export default {
    getAll (forceUpdate) {

        var areaType = sessionStorage.getItem('areaType');
        var localAreaType = sessionStorage.getItem('localAreaType');
        var busiType = sessionStorage.getItem('busiType');
        var params = {
            areaType: areaType,
            busiType: busiType
        }
        var hospitals = sessionStorage.getItem('hospitals');

        if (hospitals && !forceUpdate && areaType === localAreaType) {
            return new window.Promise(resolve => {
                resolve(JSON.parse(hospitals));
            });
        } else {
            if (areaType === '0') {
                //保存当前本地的区域类型字段
                sessionStorage.setItem('localAreaType', areaType)
                // instuteCode 机构Id,暂时为102
                return get(`/app/hospital/list/102?busiType=${busiType}`).then(res => {
                    if (res.resultCode === '1') {
                        return this.formatAll(res);
                    }
                    return res.data;
                });
            } else {
                //保存当前本地的区域类型字段
                sessionStorage.setItem('localAreaType', areaType)
                // instuteCode 机构Id,暂时为102
                // 测试用 /app/hospital/list/102?areaType={areaType}&busiType={busiType}，记得修改回来
                return get('/app/hospital/list/102?areaType={areaType}&busiType={busiType}', {
                    params: params
                }).then(res => {
                    if (res.resultCode === '1') {
                        return this.formatAll(res);
                    }
                    return res.data;
                });
            }
        }
    },
    // 医院列表数据格式化—key：字母索引,value：医院信息
    formatAll (res) {
        var hospitals = {};
        // var h1 = res.data.filter(x => x.hospitalType === 1);
        // 默认医院logo
        var h1 = res.data;
        for (var j = 0; j < res.data.length; j++) {
            if (h1[j].hospitalLogo == "" || typeof h1[j].hospitalLogo == "undefined") {
                h1[j].hospitalLogo = '../../static/img/hos-def-logo.png';
            }
        }
        hospitals["医院"] = h1;
        // var h2 = res.data.filter(x => x.hospitalType === 2);
        // for (var i = 0; i < h2.length; i++) {
        //     if (h2[i].hospitalLogo == "" || typeof h2[i].hospitalLogo == "undefined") {
        //         h2[i].hospitalLogo = '../../static/img/hos-def-logo.png';
        //     }
        //     if (hospitals[h2[i].hospitalIndex]) {
        //         hospitals[h2[i].hospitalIndex].push(h2[i]);
        //     } else {
        //         hospitals[h2[i].hospitalIndex] = [h2[i]];
        //     }
        // }
        sessionStorage.setItem('hospitals', JSON.stringify(hospitals));
        return hospitals;
    },
    getHosInfo () {
        return get('/app/hospital/info').then(res => {
            if (res.resultCode === '1') {
                return res.data;
            }
        });
    },
    getBedsInfo () {
        return get('/app/inpatient/beds').then(res => {
            if (res.resultCode === '1') {
                return res.data;
            }
        });
    },
    getInpatientMap (params) {
        return get('/app/hospital/inpatientMap/{areaId}', { params: params });
    }
}


// WEBPACK FOOTER //
// ./src/service/hospital.service.js